import * as React from "react"
import { Divider } from "@mui/material"

export default function SidebarDivider({ collapse }: { collapse?: boolean }) {
  return (
    <Divider
      light
      sx={{
        my: 1,
        mx: collapse ? 1.5 : 3,
        borderColor: "gray.200",
      }}
    />
  )
}
